export default __webpack_public_path__ + "static/media/lit-logo.433de781.png";